/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Bypass_Dialogue_HelpInputs */

const en_ad_bypass_dialogue_help = /** @type {(inputs: Ad_Bypass_Dialogue_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For short-form or commercial content where AD is not placed around dialogue. AD events are created at each scene or shot change instead.`)
};

const fr_ad_bypass_dialogue_help = /** @type {(inputs: Ad_Bypass_Dialogue_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour les contenus courts ou publicitaires où les annonces audio ne sont pas placées autour des dialogues, des événements d'annonce audio sont créés à chaque changement de scène ou de plan.`)
};

const de_ad_bypass_dialogue_help = /** @type {(inputs: Ad_Bypass_Dialogue_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei Kurzformaten oder Werbespots, in denen die Audiodeskription nicht um Dialoge herum platziert wird, werden stattdessen bei jedem Szenen- oder Einstellungswechsel Audiodeskriptionsereignisse erstellt.`)
};

const it_ad_bypass_dialogue_help = /** @type {(inputs: Ad_Bypass_Dialogue_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per contenuti di breve durata o commerciali in cui la pubblicità non è posizionata intorno ai dialoghi, gli eventi pubblicitari vengono creati a ogni cambio di scena o inquadratura.`)
};

const ru_ad_bypass_dialogue_help = /** @type {(inputs: Ad_Bypass_Dialogue_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для короткометражных или рекламных роликов, где рекламная кампания не размещается вокруг диалогов. Вместо этого рекламные события создаются при каждой сцене или смене кадра.`)
};

const es_ad_bypass_dialogue_help = /** @type {(inputs: Ad_Bypass_Dialogue_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para contenido breve o comercial donde la publicidad no se coloca alrededor del diálogo, se crean eventos de publicidad en cada cambio de escena o de plano.`)
};

const zh_cn2_ad_bypass_dialogue_help = /** @type {(inputs: Ad_Bypass_Dialogue_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对于短视频或商业内容，如果广告并非围绕对话设置，则会在每个场景或镜头切换时创建广告事件。`)
};

const ja_ad_bypass_dialogue_help = /** @type {(inputs: Ad_Bypass_Dialogue_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`短編コンテンツや商業コンテンツなど、セリフの周りに広告が配置されない場合、各シーンまたはショットの切り替え時に広告イベントが作成されます。`)
};

const hi_ad_bypass_dialogue_help = /** @type {(inputs: Ad_Bypass_Dialogue_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लघु-रूप या व्यावसायिक सामग्री के लिए जहां संवाद के आसपास विज्ञापन नहीं लगाए जाते हैं, वहां प्रत्येक दृश्य या शॉट परिवर्तन पर विज्ञापन इवेंट बनाए जाते हैं।`)
};

const pt_pt2_ad_bypass_dialogue_help = /** @type {(inputs: Ad_Bypass_Dialogue_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para conteúdo comercial ou de curta duração, onde a publicidade não é inserida em torno dos diálogos, os anúncios são criados a cada mudança de cena ou de enquadramento.`)
};

/**
* | output |
* | --- |
* | "For short-form or commercial content where AD is not placed around dialogue. AD events are created at each scene or shot change instead." |
*
* @param {Ad_Bypass_Dialogue_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_bypass_dialogue_help = /** @type {((inputs?: Ad_Bypass_Dialogue_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Bypass_Dialogue_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_bypass_dialogue_help(inputs)
	if (locale === "de") return de_ad_bypass_dialogue_help(inputs)
	if (locale === "it") return it_ad_bypass_dialogue_help(inputs)
	if (locale === "ru") return ru_ad_bypass_dialogue_help(inputs)
	if (locale === "es") return es_ad_bypass_dialogue_help(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_bypass_dialogue_help(inputs)
	if (locale === "ja") return ja_ad_bypass_dialogue_help(inputs)
	if (locale === "hi") return hi_ad_bypass_dialogue_help(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_bypass_dialogue_help(inputs)
	return en_ad_bypass_dialogue_help(inputs)
});